import { authFetch } from "utils";

export const getTenantContacts = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/tenant_contacts`, {
    method: "GET",
  });

export const saveTenantContact = (dealID, tenantContact) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/tenant_contacts/${tenantContact.id}`, {
    method: "PATCH",
    json: { tenantContact },
  });

export const createTenantContact = (dealID, tenantContact) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/tenant_contacts`, {
    method: "POST",
    json: { tenantContact },
  });

export const deleteTenantContact = (dealID, tenantContactID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/tenant_contacts/${tenantContactID}`, {
    method: "DELETE",
  });
